import styled from 'styled-components';

const NoResultContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 50px;
  text-align: center;
  width: 100%;

  .dots {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;

    .dot {
      margin-left: -4px;
      margin-right: 4px;
      display: inline-block;
      opacity: 0;
      animation: fadeInOut 1.5s infinite;
    }

    .dot:nth-child(2) {
      animation-name: fadeInOutTwo;
    }

    .dot:nth-child(3) {
      animation-name: fadeInOutThree;
    }

    @keyframes fadeInOut {
      0% {
        opacity: 0;
      }
      10% {
        opacity: 1;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    @keyframes fadeInOutTwo {
      0% {
        opacity: 0;
      }
      35% {
        opacity: 1;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    @keyframes fadeInOutThree {
      0% {
        opacity: 0;
      }
      60% {
        opacity: 1;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }

  &.no-result-modal {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export { NoResultContainer };
